export const formatDayDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
  });
};

export const getTodayDate = () => {
  const today = new Date();
  return today.toISOString().split("T")[0];
};
